module.exports = __webpack_public_path__ + "img/txlx_duoxuanti.70fb7c84.png";